export default [
  {
    path: '/brands/new',
    name: 'brandNew',
    component: () => import('./views/BrandNew'),
    meta: {
      auth: true
    }
  },
  {
    path: '/brands/:brandId',
    name: 'brandShow',
    component: () => import('./views/BrandShow'),
    meta: {
      auth: true
    }
  },
  {
    path: '/brands',
    name: 'brandIndex',
    component: () => import('./views/BrandIndex'),
    meta: {
      auth: true
    }
  }
]
